import { createClient, type SupabaseClient } from "@supabase/supabase-js";

/**
 * Cliente Supabase compartido por todas las apps del monorepo.
 * Lee la config de las env de Vite (`VITE_SUPABASE_URL` / `VITE_SUPABASE_ANON_KEY`).
 * El ANON_KEY es público por diseño; la seguridad real vive en las RLS policies de Postgres.
 */
/**
 * Schema de Postgres que usa la app (un schema por proyecto: 'tierra', 'finanzas', …).
 * Se declara por app con VITE_SUPABASE_SCHEMA; default 'public'.
 */
export function getSchema(): string {
  return (import.meta.env.VITE_SUPABASE_SCHEMA as string | undefined) ?? "public";
}

// Schema dinámico → el tipo de SchemaName es string; usamos la forma ancha del cliente.
let cached: SupabaseClient<any, any, any> | undefined;

export function getSupabase(): SupabaseClient<any, any, any> {
  if (cached) return cached;

  const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

  if (!url || !anonKey) {
    throw new Error(
      "Faltan VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY. Copiá .env.example a .env.local.",
    );
  }

  cached = createClient(url, anonKey, {
    db: { schema: getSchema() },
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  });
  return cached;
}
